module.exports = __webpack_public_path__ + "static/media/partner-story-banner1.58f8cfc3.png";